// Country codes and phone number data (excluding Israel)
export interface Country {
  code: string; // ISO 2-letter country code
  name: string;
  nameAr: string; // Arabic name
  dialCode: string; // Without + sign
  flag: string; // Unicode flag emoji
  popular?: boolean; // For Gulf/MENA region
}

export const COUNTRIES: Country[] = [
  // Gulf Countries (Popular)
  { code: 'KW', name: 'Kuwait', nameAr: 'الكويت', dialCode: '965', flag: '🇰🇼', popular: true },
  { code: 'SA', name: 'Saudi Arabia', nameAr: 'السعودية', dialCode: '966', flag: '🇸🇦', popular: true },
  { code: 'AE', name: 'United Arab Emirates', nameAr: 'الإمارات', dialCode: '971', flag: '🇦🇪', popular: true },
  { code: 'QA', name: 'Qatar', nameAr: 'قطر', dialCode: '974', flag: '🇶🇦', popular: true },
  { code: 'BH', name: 'Bahrain', nameAr: 'البحرين', dialCode: '973', flag: '🇧🇭', popular: true },
  { code: 'OM', name: 'Oman', nameAr: 'عُمان', dialCode: '968', flag: '🇴🇲', popular: true },
  
  // Other MENA Countries (Popular)
  { code: 'EG', name: 'Egypt', nameAr: 'مصر', dialCode: '20', flag: '🇪🇬', popular: true },
  { code: 'JO', name: 'Jordan', nameAr: 'الأردن', dialCode: '962', flag: '🇯🇴', popular: true },
  { code: 'LB', name: 'Lebanon', nameAr: 'لبنان', dialCode: '961', flag: '🇱🇧', popular: true },
  { code: 'SY', name: 'Syria', nameAr: 'سوريا', dialCode: '963', flag: '🇸🇾', popular: true },
  { code: 'IQ', name: 'Iraq', nameAr: 'العراق', dialCode: '964', flag: '🇮🇶', popular: true },
  { code: 'YE', name: 'Yemen', nameAr: 'اليمن', dialCode: '967', flag: '🇾🇪', popular: true },
  
  // Other Popular Countries
  { code: 'US', name: 'United States', nameAr: 'الولايات المتحدة', dialCode: '1', flag: '🇺🇸', popular: true },
  { code: 'GB', name: 'United Kingdom', nameAr: 'المملكة المتحدة', dialCode: '44', flag: '🇬🇧', popular: true },
  { code: 'IN', name: 'India', nameAr: 'الهند', dialCode: '91', flag: '🇮🇳', popular: true },
  { code: 'PK', name: 'Pakistan', nameAr: 'باكستان', dialCode: '92', flag: '🇵🇰', popular: true },
  { code: 'BD', name: 'Bangladesh', nameAr: 'بنغلاديش', dialCode: '880', flag: '🇧🇩', popular: true },
  
  // All other countries (alphabetically)
  { code: 'AD', name: 'Andorra', nameAr: 'أندورا', dialCode: '376', flag: '🇦🇩' },
  { code: 'AF', name: 'Afghanistan', nameAr: 'أفغانستان', dialCode: '93', flag: '🇦🇫' },
  { code: 'AG', name: 'Antigua and Barbuda', nameAr: 'أنتيغوا وبربودا', dialCode: '1268', flag: '🇦🇬' },
  { code: 'AI', name: 'Anguilla', nameAr: 'أنغويلا', dialCode: '1264', flag: '🇦🇮' },
  { code: 'AL', name: 'Albania', nameAr: 'ألبانيا', dialCode: '355', flag: '🇦🇱' },
  { code: 'AM', name: 'Armenia', nameAr: 'أرمينيا', dialCode: '374', flag: '🇦🇲' },
  { code: 'AO', name: 'Angola', nameAr: 'أنغولا', dialCode: '244', flag: '🇦🇴' },
  { code: 'AQ', name: 'Antarctica', nameAr: 'القارة القطبية الجنوبية', dialCode: '672', flag: '🇦🇶' },
  { code: 'AR', name: 'Argentina', nameAr: 'الأرجنتين', dialCode: '54', flag: '🇦🇷' },
  { code: 'AS', name: 'American Samoa', nameAr: 'ساموا الأمريكية', dialCode: '1684', flag: '🇦🇸' },
  { code: 'AT', name: 'Austria', nameAr: 'النمسا', dialCode: '43', flag: '🇦🇹' },
  { code: 'AU', name: 'Australia', nameAr: 'أستراليا', dialCode: '61', flag: '🇦🇺' },
  { code: 'AW', name: 'Aruba', nameAr: 'أروبا', dialCode: '297', flag: '🇦🇼' },
  { code: 'AX', name: 'Åland Islands', nameAr: 'جزر آلاند', dialCode: '358', flag: '🇦🇽' },
  { code: 'AZ', name: 'Azerbaijan', nameAr: 'أذربيجان', dialCode: '994', flag: '🇦🇿' },
  { code: 'BA', name: 'Bosnia and Herzegovina', nameAr: 'البوسنة والهرسك', dialCode: '387', flag: '🇧🇦' },
  { code: 'BB', name: 'Barbados', nameAr: 'بربادوس', dialCode: '1246', flag: '🇧🇧' },
  { code: 'BE', name: 'Belgium', nameAr: 'بلجيكا', dialCode: '32', flag: '🇧🇪' },
  { code: 'BF', name: 'Burkina Faso', nameAr: 'بوركينا فاسو', dialCode: '226', flag: '🇧🇫' },
  { code: 'BG', name: 'Bulgaria', nameAr: 'بلغاريا', dialCode: '359', flag: '🇧🇬' },
  { code: 'BI', name: 'Burundi', nameAr: 'بوروندي', dialCode: '257', flag: '🇧🇮' },
  { code: 'BJ', name: 'Benin', nameAr: 'بنين', dialCode: '229', flag: '🇧🇯' },
  { code: 'BL', name: 'Saint Barthélemy', nameAr: 'سان بارتليمي', dialCode: '590', flag: '🇧🇱' },
  { code: 'BM', name: 'Bermuda', nameAr: 'برمودا', dialCode: '1441', flag: '🇧🇲' },
  { code: 'BN', name: 'Brunei', nameAr: 'بروناي', dialCode: '673', flag: '🇧🇳' },
  { code: 'BO', name: 'Bolivia', nameAr: 'بوليفيا', dialCode: '591', flag: '🇧🇴' },
  { code: 'BQ', name: 'Caribbean Netherlands', nameAr: 'هولندا الكاريبية', dialCode: '599', flag: '🇧🇶' },
  { code: 'BR', name: 'Brazil', nameAr: 'البرازيل', dialCode: '55', flag: '🇧🇷' },
  { code: 'BS', name: 'Bahamas', nameAr: 'جزر البهاما', dialCode: '1242', flag: '🇧🇸' },
  { code: 'BT', name: 'Bhutan', nameAr: 'بوتان', dialCode: '975', flag: '🇧🇹' },
  { code: 'BV', name: 'Bouvet Island', nameAr: 'جزيرة بوفيت', dialCode: '47', flag: '🇧🇻' },
  { code: 'BW', name: 'Botswana', nameAr: 'بوتسوانا', dialCode: '267', flag: '🇧🇼' },
  { code: 'BY', name: 'Belarus', nameAr: 'بيلاروس', dialCode: '375', flag: '🇧🇾' },
  { code: 'BZ', name: 'Belize', nameAr: 'بليز', dialCode: '501', flag: '🇧🇿' },
  { code: 'CA', name: 'Canada', nameAr: 'كندا', dialCode: '1', flag: '🇨🇦' },
  { code: 'CC', name: 'Cocos Islands', nameAr: 'جزر كوكوس', dialCode: '61', flag: '🇨🇨' },
  { code: 'CD', name: 'DR Congo', nameAr: 'جمهورية الكونغو الديمقراطية', dialCode: '243', flag: '🇨🇩' },
  { code: 'CF', name: 'Central African Republic', nameAr: 'جمهورية أفريقيا الوسطى', dialCode: '236', flag: '🇨🇫' },
  { code: 'CG', name: 'Republic of the Congo', nameAr: 'جمهورية الكونغو', dialCode: '242', flag: '🇨🇬' },
  { code: 'CH', name: 'Switzerland', nameAr: 'سويسرا', dialCode: '41', flag: '🇨🇭' },
  { code: 'CI', name: 'Côte d\'Ivoire', nameAr: 'ساحل العاج', dialCode: '225', flag: '🇨🇮' },
  { code: 'CK', name: 'Cook Islands', nameAr: 'جزر كوك', dialCode: '682', flag: '🇨🇰' },
  { code: 'CL', name: 'Chile', nameAr: 'تشيلي', dialCode: '56', flag: '🇨🇱' },
  { code: 'CM', name: 'Cameroon', nameAr: 'الكاميرون', dialCode: '237', flag: '🇨🇲' },
  { code: 'CN', name: 'China', nameAr: 'الصين', dialCode: '86', flag: '🇨🇳' },
  { code: 'CO', name: 'Colombia', nameAr: 'كولومبيا', dialCode: '57', flag: '🇨🇴' },
  { code: 'CR', name: 'Costa Rica', nameAr: 'كوستاريكا', dialCode: '506', flag: '🇨🇷' },
  { code: 'CU', name: 'Cuba', nameAr: 'كوبا', dialCode: '53', flag: '🇨🇺' },
  { code: 'CV', name: 'Cape Verde', nameAr: 'الرأس الأخضر', dialCode: '238', flag: '🇨🇻' },
  { code: 'CW', name: 'Curaçao', nameAr: 'كوراساو', dialCode: '599', flag: '🇨🇼' },
  { code: 'CX', name: 'Christmas Island', nameAr: 'جزيرة الكريسماس', dialCode: '61', flag: '🇨🇽' },
  { code: 'CY', name: 'Cyprus', nameAr: 'قبرص', dialCode: '357', flag: '🇨🇾' },
  { code: 'CZ', name: 'Czech Republic', nameAr: 'التشيك', dialCode: '420', flag: '🇨🇿' },
  { code: 'DE', name: 'Germany', nameAr: 'ألمانيا', dialCode: '49', flag: '🇩🇪' },
  { code: 'DJ', name: 'Djibouti', nameAr: 'جيبوتي', dialCode: '253', flag: '🇩🇯' },
  { code: 'DK', name: 'Denmark', nameAr: 'الدنمارك', dialCode: '45', flag: '🇩🇰' },
  { code: 'DM', name: 'Dominica', nameAr: 'دومينيكا', dialCode: '1767', flag: '🇩🇲' },
  { code: 'DO', name: 'Dominican Republic', nameAr: 'جمهورية الدومينيكان', dialCode: '1', flag: '🇩🇴' },
  { code: 'DZ', name: 'Algeria', nameAr: 'الجزائر', dialCode: '213', flag: '🇩🇿' },
  { code: 'EC', name: 'Ecuador', nameAr: 'الإكوادور', dialCode: '593', flag: '🇪🇨' },
  { code: 'EE', name: 'Estonia', nameAr: 'إستونيا', dialCode: '372', flag: '🇪🇪' },
  { code: 'EH', name: 'Western Sahara', nameAr: 'الصحراء الغربية', dialCode: '212', flag: '🇪🇭' },
  { code: 'ER', name: 'Eritrea', nameAr: 'إريتريا', dialCode: '291', flag: '🇪🇷' },
  { code: 'ES', name: 'Spain', nameAr: 'إسبانيا', dialCode: '34', flag: '🇪🇸' },
  { code: 'ET', name: 'Ethiopia', nameAr: 'إثيوبيا', dialCode: '251', flag: '🇪🇹' },
  { code: 'FI', name: 'Finland', nameAr: 'فنلندا', dialCode: '358', flag: '🇫🇮' },
  { code: 'FJ', name: 'Fiji', nameAr: 'فيجي', dialCode: '679', flag: '🇫🇯' },
  { code: 'FK', name: 'Falkland Islands', nameAr: 'جزر فوكلاند', dialCode: '500', flag: '🇫🇰' },
  { code: 'FM', name: 'Micronesia', nameAr: 'ميكرونيزيا', dialCode: '691', flag: '🇫🇲' },
  { code: 'FO', name: 'Faroe Islands', nameAr: 'جزر فارو', dialCode: '298', flag: '🇫🇴' },
  { code: 'FR', name: 'France', nameAr: 'فرنسا', dialCode: '33', flag: '🇫🇷' },
  { code: 'GA', name: 'Gabon', nameAr: 'الغابون', dialCode: '241', flag: '🇬🇦' },
  { code: 'GD', name: 'Grenada', nameAr: 'غرينادا', dialCode: '1473', flag: '🇬🇩' },
  { code: 'GE', name: 'Georgia', nameAr: 'جورجيا', dialCode: '995', flag: '🇬🇪' },
  { code: 'GF', name: 'French Guiana', nameAr: 'غويانا الفرنسية', dialCode: '594', flag: '🇬🇫' },
  { code: 'GG', name: 'Guernsey', nameAr: 'غيرنزي', dialCode: '44', flag: '🇬🇬' },
  { code: 'GH', name: 'Ghana', nameAr: 'غانا', dialCode: '233', flag: '🇬🇭' },
  { code: 'GI', name: 'Gibraltar', nameAr: 'جبل طارق', dialCode: '350', flag: '🇬🇮' },
  { code: 'GL', name: 'Greenland', nameAr: 'جرينلاند', dialCode: '299', flag: '🇬🇱' },
  { code: 'GM', name: 'Gambia', nameAr: 'غامبيا', dialCode: '220', flag: '🇬🇲' },
  { code: 'GN', name: 'Guinea', nameAr: 'غينيا', dialCode: '224', flag: '🇬🇳' },
  { code: 'GP', name: 'Guadeloupe', nameAr: 'جوادلوب', dialCode: '590', flag: '🇬🇵' },
  { code: 'GQ', name: 'Equatorial Guinea', nameAr: 'غينيا الاستوائية', dialCode: '240', flag: '🇬🇶' },
  { code: 'GR', name: 'Greece', nameAr: 'اليونان', dialCode: '30', flag: '🇬🇷' },
  { code: 'GS', name: 'South Georgia', nameAr: 'جورجيا الجنوبية', dialCode: '500', flag: '🇬🇸' },
  { code: 'GT', name: 'Guatemala', nameAr: 'غواتيمالا', dialCode: '502', flag: '🇬🇹' },
  { code: 'GU', name: 'Guam', nameAr: 'غوام', dialCode: '1671', flag: '🇬🇺' },
  { code: 'GW', name: 'Guinea-Bissau', nameAr: 'غينيا بيساو', dialCode: '245', flag: '🇬🇼' },
  { code: 'GY', name: 'Guyana', nameAr: 'غيانا', dialCode: '592', flag: '🇬🇾' },
  { code: 'HK', name: 'Hong Kong', nameAr: 'هونغ كونغ', dialCode: '852', flag: '🇭🇰' },
  { code: 'HM', name: 'Heard Island', nameAr: 'جزيرة هيرد', dialCode: '672', flag: '🇭🇲' },
  { code: 'HN', name: 'Honduras', nameAr: 'هندوراس', dialCode: '504', flag: '🇭🇳' },
  { code: 'HR', name: 'Croatia', nameAr: 'كرواتيا', dialCode: '385', flag: '🇭🇷' },
  { code: 'HT', name: 'Haiti', nameAr: 'هايتي', dialCode: '509', flag: '🇭🇹' },
  { code: 'HU', name: 'Hungary', nameAr: 'المجر', dialCode: '36', flag: '🇭🇺' },
  { code: 'ID', name: 'Indonesia', nameAr: 'إندونيسيا', dialCode: '62', flag: '🇮🇩' },
  { code: 'IE', name: 'Ireland', nameAr: 'أيرلندا', dialCode: '353', flag: '🇮🇪' },
  { code: 'IM', name: 'Isle of Man', nameAr: 'جزيرة مان', dialCode: '44', flag: '🇮🇲' },
  { code: 'IO', name: 'British Indian Ocean Territory', nameAr: 'إقليم المحيط الهندي البريطاني', dialCode: '246', flag: '🇮🇴' },
  { code: 'IR', name: 'Iran', nameAr: 'إيران', dialCode: '98', flag: '🇮🇷' },
  { code: 'IS', name: 'Iceland', nameAr: 'أيسلندا', dialCode: '354', flag: '🇮🇸' },
  { code: 'IT', name: 'Italy', nameAr: 'إيطاليا', dialCode: '39', flag: '🇮🇹' },
  { code: 'JE', name: 'Jersey', nameAr: 'جيرسي', dialCode: '44', flag: '🇯🇪' },
  { code: 'JM', name: 'Jamaica', nameAr: 'جامايكا', dialCode: '1876', flag: '🇯🇲' },
  { code: 'JP', name: 'Japan', nameAr: 'اليابان', dialCode: '81', flag: '🇯🇵' },
  { code: 'KE', name: 'Kenya', nameAr: 'كينيا', dialCode: '254', flag: '🇰🇪' },
  { code: 'KG', name: 'Kyrgyzstan', nameAr: 'قيرغيزستان', dialCode: '996', flag: '🇰🇬' },
  { code: 'KH', name: 'Cambodia', nameAr: 'كمبوديا', dialCode: '855', flag: '🇰🇭' },
  { code: 'KI', name: 'Kiribati', nameAr: 'كيريباتي', dialCode: '686', flag: '🇰🇮' },
  { code: 'KM', name: 'Comoros', nameAr: 'جزر القمر', dialCode: '269', flag: '🇰🇲' },
  { code: 'KN', name: 'Saint Kitts and Nevis', nameAr: 'سانت كيتس ونيفيس', dialCode: '1869', flag: '🇰🇳' },
  { code: 'KP', name: 'North Korea', nameAr: 'كوريا الشمالية', dialCode: '850', flag: '🇰🇵' },
  { code: 'KR', name: 'South Korea', nameAr: 'كوريا الجنوبية', dialCode: '82', flag: '🇰🇷' },
  { code: 'KY', name: 'Cayman Islands', nameAr: 'جزر كايمان', dialCode: '1345', flag: '🇰🇾' },
  { code: 'KZ', name: 'Kazakhstan', nameAr: 'كازاخستان', dialCode: '7', flag: '🇰🇿' },
  { code: 'LA', name: 'Laos', nameAr: 'لاوس', dialCode: '856', flag: '🇱🇦' },
  { code: 'LC', name: 'Saint Lucia', nameAr: 'سانت لوسيا', dialCode: '1758', flag: '🇱🇨' },
  { code: 'LI', name: 'Liechtenstein', nameAr: 'ليختنشتاين', dialCode: '423', flag: '🇱🇮' },
  { code: 'LK', name: 'Sri Lanka', nameAr: 'سريلانكا', dialCode: '94', flag: '🇱🇰' },
  { code: 'LR', name: 'Liberia', nameAr: 'ليبيريا', dialCode: '231', flag: '🇱🇷' },
  { code: 'LS', name: 'Lesotho', nameAr: 'ليسوتو', dialCode: '266', flag: '🇱🇸' },
  { code: 'LT', name: 'Lithuania', nameAr: 'ليتوانيا', dialCode: '370', flag: '🇱🇹' },
  { code: 'LU', name: 'Luxembourg', nameAr: 'لوكسمبورغ', dialCode: '352', flag: '🇱🇺' },
  { code: 'LV', name: 'Latvia', nameAr: 'لاتفيا', dialCode: '371', flag: '🇱🇻' },
  { code: 'LY', name: 'Libya', nameAr: 'ليبيا', dialCode: '218', flag: '🇱🇾' },
  { code: 'MA', name: 'Morocco', nameAr: 'المغرب', dialCode: '212', flag: '🇲🇦' },
  { code: 'MC', name: 'Monaco', nameAr: 'موناكو', dialCode: '377', flag: '🇲🇨' },
  { code: 'MD', name: 'Moldova', nameAr: 'مولدوفا', dialCode: '373', flag: '🇲🇩' },
  { code: 'ME', name: 'Montenegro', nameAr: 'الجبل الأسود', dialCode: '382', flag: '🇲🇪' },
  { code: 'MF', name: 'Saint Martin', nameAr: 'سان مارتن', dialCode: '590', flag: '🇲🇫' },
  { code: 'MG', name: 'Madagascar', nameAr: 'مدغشقر', dialCode: '261', flag: '🇲🇬' },
  { code: 'MH', name: 'Marshall Islands', nameAr: 'جزر مارشال', dialCode: '692', flag: '🇲🇭' },
  { code: 'MK', name: 'North Macedonia', nameAr: 'مقدونيا الشمالية', dialCode: '389', flag: '🇲🇰' },
  { code: 'ML', name: 'Mali', nameAr: 'مالي', dialCode: '223', flag: '🇲🇱' },
  { code: 'MM', name: 'Myanmar', nameAr: 'ميانمار', dialCode: '95', flag: '🇲🇲' },
  { code: 'MN', name: 'Mongolia', nameAr: 'منغوليا', dialCode: '976', flag: '🇲🇳' },
  { code: 'MO', name: 'Macau', nameAr: 'ماكاو', dialCode: '853', flag: '🇲🇴' },
  { code: 'MP', name: 'Northern Mariana Islands', nameAr: 'جزر ماريانا الشمالية', dialCode: '1670', flag: '🇲🇵' },
  { code: 'MQ', name: 'Martinique', nameAr: 'مارتينيك', dialCode: '596', flag: '🇲🇶' },
  { code: 'MR', name: 'Mauritania', nameAr: 'موريتانيا', dialCode: '222', flag: '🇲🇷' },
  { code: 'MS', name: 'Montserrat', nameAr: 'مونتسرات', dialCode: '1664', flag: '🇲🇸' },
  { code: 'MT', name: 'Malta', nameAr: 'مالطا', dialCode: '356', flag: '🇲🇹' },
  { code: 'MU', name: 'Mauritius', nameAr: 'موريشيوس', dialCode: '230', flag: '🇲🇺' },
  { code: 'MV', name: 'Maldives', nameAr: 'المالديف', dialCode: '960', flag: '🇲🇻' },
  { code: 'MW', name: 'Malawi', nameAr: 'ملاوي', dialCode: '265', flag: '🇲🇼' },
  { code: 'MX', name: 'Mexico', nameAr: 'المكسيك', dialCode: '52', flag: '🇲🇽' },
  { code: 'MY', name: 'Malaysia', nameAr: 'ماليزيا', dialCode: '60', flag: '🇲🇾' },
  { code: 'MZ', name: 'Mozambique', nameAr: 'موزمبيق', dialCode: '258', flag: '🇲🇿' },
  { code: 'NA', name: 'Namibia', nameAr: 'ناميبيا', dialCode: '264', flag: '🇳🇦' },
  { code: 'NC', name: 'New Caledonia', nameAr: 'كاليدونيا الجديدة', dialCode: '687', flag: '🇳🇨' },
  { code: 'NE', name: 'Niger', nameAr: 'النيجر', dialCode: '227', flag: '🇳🇪' },
  { code: 'NF', name: 'Norfolk Island', nameAr: 'جزيرة نورفولك', dialCode: '672', flag: '🇳🇫' },
  { code: 'NG', name: 'Nigeria', nameAr: 'نيجيريا', dialCode: '234', flag: '🇳🇬' },
  { code: 'NI', name: 'Nicaragua', nameAr: 'نيكاراغوا', dialCode: '505', flag: '🇳🇮' },
  { code: 'NL', name: 'Netherlands', nameAr: 'هولندا', dialCode: '31', flag: '🇳🇱' },
  { code: 'NO', name: 'Norway', nameAr: 'النرويج', dialCode: '47', flag: '🇳🇴' },
  { code: 'NP', name: 'Nepal', nameAr: 'نيبال', dialCode: '977', flag: '🇳🇵' },
  { code: 'NR', name: 'Nauru', nameAr: 'ناورو', dialCode: '674', flag: '🇳🇷' },
  { code: 'NU', name: 'Niue', nameAr: 'نيوي', dialCode: '683', flag: '🇳🇺' },
  { code: 'NZ', name: 'New Zealand', nameAr: 'نيوزيلندا', dialCode: '64', flag: '🇳🇿' },
  { code: 'PA', name: 'Panama', nameAr: 'بنما', dialCode: '507', flag: '🇵🇦' },
  { code: 'PE', name: 'Peru', nameAr: 'بيرو', dialCode: '51', flag: '🇵🇪' },
  { code: 'PF', name: 'French Polynesia', nameAr: 'بولينيزيا الفرنسية', dialCode: '689', flag: '🇵🇫' },
  { code: 'PG', name: 'Papua New Guinea', nameAr: 'بابوا غينيا الجديدة', dialCode: '675', flag: '🇵🇬' },
  { code: 'PH', name: 'Philippines', nameAr: 'الفلبين', dialCode: '63', flag: '🇵🇭' },
  { code: 'PL', name: 'Poland', nameAr: 'بولندا', dialCode: '48', flag: '🇵🇱' },
  { code: 'PM', name: 'Saint Pierre and Miquelon', nameAr: 'سان بيير وميكلون', dialCode: '508', flag: '🇵🇲' },
  { code: 'PN', name: 'Pitcairn Islands', nameAr: 'جزر بيتكيرن', dialCode: '64', flag: '🇵🇳' },
  { code: 'PR', name: 'Puerto Rico', nameAr: 'بورتوريكو', dialCode: '1787', flag: '🇵🇷' },
  { code: 'PS', name: 'Palestine', nameAr: 'فلسطين', dialCode: '970', flag: '🇵🇸' },
  { code: 'PT', name: 'Portugal', nameAr: 'البرتغال', dialCode: '351', flag: '🇵🇹' },
  { code: 'PW', name: 'Palau', nameAr: 'بالاو', dialCode: '680', flag: '🇵🇼' },
  { code: 'PY', name: 'Paraguay', nameAr: 'باراغواي', dialCode: '595', flag: '🇵🇾' },
  { code: 'RE', name: 'Réunion', nameAr: 'ريونيون', dialCode: '262', flag: '🇷🇪' },
  { code: 'RO', name: 'Romania', nameAr: 'رومانيا', dialCode: '40', flag: '🇷🇴' },
  { code: 'RS', name: 'Serbia', nameAr: 'صربيا', dialCode: '381', flag: '🇷🇸' },
  { code: 'RU', name: 'Russia', nameAr: 'روسيا', dialCode: '7', flag: '🇷🇺' },
  { code: 'RW', name: 'Rwanda', nameAr: 'رواندا', dialCode: '250', flag: '🇷🇼' },
  { code: 'SB', name: 'Solomon Islands', nameAr: 'جزر سليمان', dialCode: '677', flag: '🇸🇧' },
  { code: 'SC', name: 'Seychelles', nameAr: 'سيشل', dialCode: '248', flag: '🇸🇨' },
  { code: 'SD', name: 'Sudan', nameAr: 'السودان', dialCode: '249', flag: '🇸🇩' },
  { code: 'SE', name: 'Sweden', nameAr: 'السويد', dialCode: '46', flag: '🇸🇪' },
  { code: 'SG', name: 'Singapore', nameAr: 'سنغافورة', dialCode: '65', flag: '🇸🇬' },
  { code: 'SH', name: 'Saint Helena', nameAr: 'سانت هيلينا', dialCode: '290', flag: '🇸🇭' },
  { code: 'SI', name: 'Slovenia', nameAr: 'سلوفينيا', dialCode: '386', flag: '🇸🇮' },
  { code: 'SJ', name: 'Svalbard and Jan Mayen', nameAr: 'سفالبارد وجان ماين', dialCode: '47', flag: '🇸🇯' },
  { code: 'SK', name: 'Slovakia', nameAr: 'سلوفاكيا', dialCode: '421', flag: '🇸🇰' },
  { code: 'SL', name: 'Sierra Leone', nameAr: 'سيراليون', dialCode: '232', flag: '🇸🇱' },
  { code: 'SM', name: 'San Marino', nameAr: 'سان مارينو', dialCode: '378', flag: '🇸🇲' },
  { code: 'SN', name: 'Senegal', nameAr: 'السنغال', dialCode: '221', flag: '🇸🇳' },
  { code: 'SO', name: 'Somalia', nameAr: 'الصومال', dialCode: '252', flag: '🇸🇴' },
  { code: 'SR', name: 'Suriname', nameAr: 'سورينام', dialCode: '597', flag: '🇸🇷' },
  { code: 'SS', name: 'South Sudan', nameAr: 'جنوب السودان', dialCode: '211', flag: '🇸🇸' },
  { code: 'ST', name: 'São Tomé and Príncipe', nameAr: 'ساو تومي وبرينسيب', dialCode: '239', flag: '🇸🇹' },
  { code: 'SV', name: 'El Salvador', nameAr: 'السلفادور', dialCode: '503', flag: '🇸🇻' },
  { code: 'SX', name: 'Sint Maarten', nameAr: 'سينت مارتن', dialCode: '1721', flag: '🇸🇽' },
  { code: 'SZ', name: 'Eswatini', nameAr: 'إسواتيني', dialCode: '268', flag: '🇸🇿' },
  { code: 'TC', name: 'Turks and Caicos Islands', nameAr: 'جزر تركس وكايكوس', dialCode: '1649', flag: '🇹🇨' },
  { code: 'TD', name: 'Chad', nameAr: 'تشاد', dialCode: '235', flag: '🇹🇩' },
  { code: 'TF', name: 'French Southern Territories', nameAr: 'الأقاليم الجنوبية الفرنسية', dialCode: '262', flag: '🇹🇫' },
  { code: 'TG', name: 'Togo', nameAr: 'توغو', dialCode: '228', flag: '🇹🇬' },
  { code: 'TH', name: 'Thailand', nameAr: 'تايلاند', dialCode: '66', flag: '🇹🇭' },
  { code: 'TJ', name: 'Tajikistan', nameAr: 'طاجيكستان', dialCode: '992', flag: '🇹🇯' },
  { code: 'TK', name: 'Tokelau', nameAr: 'توكيلاو', dialCode: '690', flag: '🇹🇰' },
  { code: 'TL', name: 'Timor-Leste', nameAr: 'تيمور الشرقية', dialCode: '670', flag: '🇹🇱' },
  { code: 'TM', name: 'Turkmenistan', nameAr: 'تركمانستان', dialCode: '993', flag: '🇹🇲' },
  { code: 'TN', name: 'Tunisia', nameAr: 'تونس', dialCode: '216', flag: '🇹🇳' },
  { code: 'TO', name: 'Tonga', nameAr: 'تونغا', dialCode: '676', flag: '🇹🇴' },
  { code: 'TR', name: 'Turkey', nameAr: 'تركيا', dialCode: '90', flag: '🇹🇷' },
  { code: 'TT', name: 'Trinidad and Tobago', nameAr: 'ترينيداد وتوباغو', dialCode: '1868', flag: '🇹🇹' },
  { code: 'TV', name: 'Tuvalu', nameAr: 'توفالو', dialCode: '688', flag: '🇹🇻' },
  { code: 'TW', name: 'Taiwan', nameAr: 'تايوان', dialCode: '886', flag: '🇹🇼' },
  { code: 'TZ', name: 'Tanzania', nameAr: 'تنزانيا', dialCode: '255', flag: '🇹🇿' },
  { code: 'UA', name: 'Ukraine', nameAr: 'أوكرانيا', dialCode: '380', flag: '🇺🇦' },
  { code: 'UG', name: 'Uganda', nameAr: 'أوغندا', dialCode: '256', flag: '🇺🇬' },
  { code: 'UM', name: 'U.S. Outlying Islands', nameAr: 'الجزر النائية للولايات المتحدة', dialCode: '1', flag: '🇺🇲' },
  { code: 'UY', name: 'Uruguay', nameAr: 'أوروغواي', dialCode: '598', flag: '🇺🇾' },
  { code: 'UZ', name: 'Uzbekistan', nameAr: 'أوزبكستان', dialCode: '998', flag: '🇺🇿' },
  { code: 'VA', name: 'Vatican City', nameAr: 'مدينة الفاتيكان', dialCode: '39', flag: '🇻🇦' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', nameAr: 'سانت فنسنت والغرينادين', dialCode: '1784', flag: '🇻🇨' },
  { code: 'VE', name: 'Venezuela', nameAr: 'فنزويلا', dialCode: '58', flag: '🇻🇪' },
  { code: 'VG', name: 'British Virgin Islands', nameAr: 'جزر العذراء البريطانية', dialCode: '1284', flag: '🇻🇬' },
  { code: 'VI', name: 'U.S. Virgin Islands', nameAr: 'جزر العذراء الأمريكية', dialCode: '1340', flag: '🇻🇮' },
  { code: 'VN', name: 'Vietnam', nameAr: 'فيتنام', dialCode: '84', flag: '🇻🇳' },
  { code: 'VU', name: 'Vanuatu', nameAr: 'فانواتو', dialCode: '678', flag: '🇻🇺' },
  { code: 'WF', name: 'Wallis and Futuna', nameAr: 'واليس وفوتونا', dialCode: '681', flag: '🇼🇫' },
  { code: 'WS', name: 'Samoa', nameAr: 'ساموا', dialCode: '685', flag: '🇼🇸' },
  { code: 'XK', name: 'Kosovo', nameAr: 'كوسوفو', dialCode: '383', flag: '🇽🇰' },
  { code: 'ZA', name: 'South Africa', nameAr: 'جنوب أفريقيا', dialCode: '27', flag: '🇿🇦' },
  { code: 'ZM', name: 'Zambia', nameAr: 'زامبيا', dialCode: '260', flag: '🇿🇲' },
  { code: 'ZW', name: 'Zimbabwe', nameAr: 'زيمبابوي', dialCode: '263', flag: '🇿🇼' }
];

// Helper functions
export const getPopularCountries = (): Country[] => {
  return COUNTRIES.filter(country => country.popular);
};

export const getCountryByCode = (code: string): Country | undefined => {
  return COUNTRIES.find(country => country.code === code);
};

export const getCountryByDialCode = (dialCode: string): Country | undefined => {
  return COUNTRIES.find(country => country.dialCode === dialCode);
};

export const searchCountries = (query: string): Country[] => {
  const lowercaseQuery = query.toLowerCase();
  return COUNTRIES.filter(country => 
    country.name.toLowerCase().includes(lowercaseQuery) ||
    country.nameAr.includes(query) ||
    country.dialCode.includes(query) ||
    country.code.toLowerCase().includes(lowercaseQuery)
  );
};